import { format, subDays } from "date-fns";

import type {
  CommunityPromptPostPrayer,
  DefaultPostPrayer,
  ForYouPostPrayer,
  HighlightsPostPrayer,
  IntentionsPostPrayer,
  PrayerGoalPostPrayer,
  PromptPostPrayer,
  RatingPostPrayer,
  ReflectionPostPrayer,
  SignupPostPrayer,
  StreakPostPrayer,
  SubscriptionPostPrayer,
  SummaryPostPrayer,
} from "../../src";
import { CommunityStatus, CommunityType, StreakPart } from "../../src";
import { mockPlayablePrayers } from "./mockPlayablePrayers";
import { mockRecommendationDeeplink } from "./mockRecommendationDeeplink";

export const mockAutoRoutineStep: DefaultPostPrayer = {
  id: 19,
  title: "Added to Your Routine!",
  type: "default",
  super_title: "Routines",
  image_url: "https://images.hallow.app/covers/17_l.png",
  deeplink: null,
  button_text: "OK",
  desc: format(new Date(), "h:mm aaa"),
  secondary_button_text: "Edit Routine",
  secondary_deeplink: "hallow://routine/items/1/edit",
};

export const mockRatingStep: RatingPostPrayer = {
  id: 1,
  type: "rating",
};

export const mockSubscriptionStep: SubscriptionPostPrayer = {
  id: 9,
  type: "subscription",
};

export const mockRoutineStep: DefaultPostPrayer = {
  id: 11,
  type: "default",
  title: "Daily Rosary",
  super_title: "Routines",
  secondary_deeplink: `hallow://routine/items/create?reference_type=prayer&reference_id=1601&time=${new Date().toISOString()}`,
  image_url: "https://images.hallow.app/covers/16_l.png",
  button_text: "",
  desc: "Add to your routine",
  secondary_button_text: "Add to Routine",
};

export const mockSummaryStep: SummaryPostPrayer = {
  type: "summary",
  id: 16,
  sessions: mockPlayablePrayers,
  groups: [],
  streak: {
    activity: [
      {
        has_session: true,
        date: subDays(new Date(), 5).toISOString(),
        is_today: false,
        goal_met: false,
        streak: StreakPart.End,
      },
      {
        has_session: true,
        date: subDays(new Date(), 3).toISOString(),
        is_today: false,
        goal_met: false,
        streak: StreakPart.Start,
      },
      {
        has_session: true,
        date: subDays(new Date(), 2).toISOString(),
        is_today: false,
        goal_met: false,
        streak: StreakPart.Middle,
      },
      {
        has_session: true,
        date: subDays(new Date(), 1).toISOString(),
        is_today: false,
        goal_met: false,
        streak: StreakPart.Middle,
      },
      {
        has_session: true,
        date: new Date().toISOString(),
        is_today: true,
        goal_met: false,
        streak: StreakPart.End,
      },
    ],
    current_total: 4,
  },
};

export const mockSignupStep: SignupPostPrayer = {
  id: 17,
  type: "signup",
};

export const mockIntentionsStep: IntentionsPostPrayer = {
  id: 21,
  type: "intentions",
  intention: {
    id: 5,
    author_text: "some author",
    text: "Please pray for the people of Florin in this trying time of war with Gilder.",
    is_pinned: false,
    group_id: 7,
    post_id: 53,
    is_private: false,
    created_at: new Date().toISOString(),
  },
};

export const mockPrayerGoalStep: PrayerGoalPostPrayer = {
  id: 22,
  type: "prayer_goal_met",
  title: "Way to go!",
  completion_message:
    "You completed the Be Super Awesome at Praying goal by completing this random prayer!",
  prayer_goal: {
    id: 12,
    name: "Be Super Awesome at Praying",
    desc: "Pray some particular prayer really really well.",
    incomplete_image_url:
      "https://images.hallow.app/prayer-goals/bible_in_a_year_bw.png",
    complete_image_url:
      "https://images.hallow.app/prayer-goals/bible_in_a_year_color.png",
    is_met: true,
    current_item_count: 1,
    total_items_needed: 1,
    progress_desc: "You have made progress, my Padawan",
  },
};

export const mockStreakStep: StreakPostPrayer = {
  id: 25,
  type: "streak",
  streak: mockSummaryStep.streak,
  title: "Keep it up!",
  subtitle: "You are on a 4 day streak",
};

export const mockHighlightsStep: HighlightsPostPrayer = {
  id: 26,
  type: "highlights",
  sessions: mockPlayablePrayers,
  groups: [],
};

export const mockReflectionStep: ReflectionPostPrayer = {
  id: 27,
  type: "reflection",
  session: mockPlayablePrayers.slice(-1)[0],
  groups: [],
};

export const mockForYouStep: ForYouPostPrayer = {
  id: 28,
  type: "for_you",
  title: "",
  recommendations: [mockRecommendationDeeplink, mockRecommendationDeeplink],
};

export const mockPromptStep: PromptPostPrayer = {
  id: 30,
  type: "prompt",
  session: mockPlayablePrayers.slice(4, 5)[0],
  parish: null,
  response: null,
};

export const mockCommunityPromptStep: CommunityPromptPostPrayer = {
  id: 36,
  type: "community_prompt",
  session: mockPlayablePrayers.slice(2, 3)[0],
  community: {
    id: 7,
    description: "some community",
    image_url: null,
    color_hex: "#ABCDEF",
    address: null,
    name: "A Wonderful Place",
    status: CommunityStatus.active,
    launched_at: "2024-05-05T00:00:00.000Z",
    type: CommunityType.parish,
    created_at: "2024-01-01T00:00:00.000Z",
    updated_at: "2024-01-01T00:00:00.000Z",
    is_non_admin_content_allowed: false,
    address_label: "some label",
    simple_address_label: "shorter label?",
    member_summary: {
      member_count: 1,
      image_urls: [""],
      is_member: true,
      network_member_count: 10,
    },
    is_nonadmin_content_allowed: false,
    sharing_defaults: {
      intentions: true,
      prompt_responses: true,
    },
    is_admin: false,
    has_requested_admin: true,
    parent_community_id: null,
    tag_text: null,
    parent_details: null,
    current_contract: null,
  },
  response: {
    id: 467,
    text: "some response",
    user: {
      id: 47,
      name: "Bob",
      last_name: null,
      username: "whataboutbob",
      image_url: "",
      is_admin: false,
      bio: null,
      relation_description: null,
      is_self: false,
      is_friend: true,
      relationship_state: "friends",
    },
  },
};
